'use client'

import React from 'react';
import { SignIn } from "@clerk/nextjs";
import { useSearchParams } from 'next/navigation';
import Link from 'next/link';
import Image from 'next/image';

const BackgroundShapes = () => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none">
    <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-[#49A8FF] rounded-full opacity-20 blur-3xl"></div>
    <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#FF7CC3] rounded-full opacity-20 blur-3xl"></div>
    <div className="absolute top-3/4 left-1/2 w-48 h-48 bg-[#FFB64F] rounded-full opacity-20 blur-3xl"></div>
  </div>
);

export default function Page() {
  const searchParams = useSearchParams();
  const ref = searchParams.get('ref');
  
  return (
    <div>
      <div className="absolute top-0 left-0 z-10">
        <Link href="/">
          <div className="relative h-8 w-auto ml-10 mt-10">
            <Image
              src="https://storage.googleapis.com/saved_media_assets/SavedLogo.png"
              alt="Saved Logo"
              width={128}
              height={32}
              priority
              className="h-8 w-auto"
            />
          </div>
        </Link>
      </div>
      <div className="min-h-screen bg-[#171717] flex flex-col items-center justify-center relative">
        <BackgroundShapes />
        <div className="z-10 w-full max-w-md">
          <SignIn           
            appearance={{
              elements: {
                formButtonPrimary: 'bg-gray-800 hover:bg-gray-700',
                footerActionLink: 'text-gray-400 hover:text-gray-300',
              },
            }}
            forceRedirectUrl={
              ref === 'hero' ? '/post-login' : 
              ref === 'pricing' ? '/pricing' :
              '/bot-setup'
            }
            fallbackRedirectUrl={'/bot-setup'}
          />
        </div>
      </div>
    </div>
  );
}